import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import Navbar from "./Navbar";
import Hero from "./Hero";
import Advantages from "./Advantages";
import ProductGrid from "./ProductGrid";
import Testimonials from "./Testimonials";
import Contact from "./Contact";
import Footer from "./Footer";
import { MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/2250716421345?text=Bonjour, je souhaite des informations sur vos produits";

export default function LandingPage() {
  const scrollRef = useScrollAnimation();

  return (
    <div ref={scrollRef} className="min-h-screen bg-[#F5F0E8]">
      <Navbar />
      <Hero />
      <Advantages />
      <ProductGrid />
      <Testimonials />
      <Contact />
      <Footer />

      {/* Floating WhatsApp Button - Mobile */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#128C7E] text-white rounded-full flex items-center justify-center shadow-xl shadow-[#25D366]/30 transition-all duration-200 hover:scale-110 md:hidden"
        aria-label="Contacter sur WhatsApp"
      >
        <MessageCircle size={26} fill="white" strokeWidth={0} />
      </a>
    </div>
  );
}
